import Vue from 'vue';

/* This works for legacy system http://warroom.stilingue.com.br/img/profiles/avatar.png */
const DEFAULT_IMAGE = '/img/profiles/avatar.png';

function cssify(size) {
  if (isNaN(size)) {
    return size;
  }

  return `${size}px`;
}

function generateStyle(element) {
  const width = element.getAttribute('width') || element.style.width;
  const height = element.getAttribute('height') || element.style.height;

  return `
    height: ${cssify(height)};
    width: ${cssify(width)};
    line-height: ${cssify(height)};
    font-size: 15px;
	  font-weight: 600;
	  display: inline-block;
	  text-align: center;
	  border-radius: 50%;
	  vertical-align: middle;
	  margin: 0 auto;
  `;
}

function getInitials(fullName) {
  const [firstName, ...otherNames] = fullName.split(' ');
  if (!otherNames.length) return firstName[0];
  return firstName[0] + otherNames.pop()[0];
}

function getAvatarData({ id, userId: backendUserId, name, title }) {
  const userId = Number(id || backendUserId);
  const initialsGroup = userId % 5;

  return {
    initials: getInitials(name || title).toUpperCase(),
    initialsGroup
  };
}

function loadFakeAvatar(element, img, user) {
  img.style.display = 'none';
  const { initials, initialsGroup } = getAvatarData(user);
  img.parentNode && (
    img.outerHTML = `
    <div class="avatar__initials avatar__initials-group-${initialsGroup}" style="${generateStyle(element)}">
		    ${initials}
		</div>`
  );
}

function isImage(element) {
  return element.tagName === 'IMG';
}

function isAvatarPathValid(src, dataSrc) {
  // ignore paths when userImagePath ends with '/avatar' or '/avatar.png'
  const invalidAvatars = ['/avatar', '/avatar.png'];
  for (const invalidAvatar of invalidAvatars) {
    const invalidSrc = src && src.endsWith(invalidAvatar);
    const invalidDataSrc = dataSrc && dataSrc.endsWith(invalidAvatar);
    if (invalidSrc || invalidDataSrc) {
      return false;
    }
  }

  return true;
}

const fakeAvatarDirective = {
  bind(element, { value: user }) {
    const image = Array.from(element.children).find(isImage);

    /* istanbul ignore next  */
    if (!image) {
      return;
    }

    const src = image.getAttribute('src');
    const dataSrc = image.dataset.src;

    let isValidAvatar = isAvatarPathValid(src, dataSrc);
    isValidAvatar &= !(src === DEFAULT_IMAGE || dataSrc === DEFAULT_IMAGE);

    if ((!src && !dataSrc) || !isValidAvatar) {
      loadFakeAvatar(element, image, user);
    }

    image.addEventListener('error', loadFakeAvatar.bind(null, element, image, user));
  }
};

Vue.directive('fake-avatar', fakeAvatarDirective);

export default fakeAvatarDirective;
